import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const PatientInfoForm = ({ 
  patientName, 
  setPatientName, 
  notes, 
  setNotes, 
  analysisDate, 
  setAnalysisDate,
  errors 
}) => {
  return (
    <div className="space-y-6">

      {/* NAME + DATE */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <label className="text-sm font-semibold text-white flex items-center">
            <Icon name="User" size={16} className="mr-2 text-white" />
            Patient Name *
          </label>
          <Input
            type="text"
            placeholder="Enter patient's full name"
            value={patientName}
            onChange={(e) => setPatientName(e?.target?.value)}
            error={errors?.patientName}
            className="w-full bg-white/10 text-white placeholder-slate-300 
                       border-white/20 focus:border-cyan-400 
                       focus:ring-cyan-400/20"
          />
        </div>

        <div className="space-y-2">
          <label className="text-sm font-semibold text-white flex items-center">
            <Icon name="Calendar" size={16} className="mr-2 text-white" />
            Analysis Date *
          </label>
          <Input
            type="date"
            value={analysisDate}
            onChange={(e) => setAnalysisDate(e?.target?.value)}
            error={errors?.analysisDate}
            className="w-full bg-white/10 text-white border-white/20
                       focus:border-cyan-400 focus:ring-cyan-400/20"
          />
        </div>
      </div>

      {/* NOTES */}
      <div className="space-y-2">
        <label className="text-sm font-semibold text-white flex items-center">
          <Icon name="FileText" size={16} className="mr-2 text-white" />
          Clinical Notes
          <span className="text-slate-300 font-normal ml-1">(Optional)</span>
        </label>

        <Input
          type="textarea"
          placeholder="Add clinical observations, procedure details, or any relevant notes..."
          value={notes}
          onChange={(e) => setNotes(e?.target?.value)}
          className="w-full bg-white/10 text-white placeholder-slate-300 
                     border-white/20 focus:border-cyan-400 
                     focus:ring-cyan-400/20"
          rows={3}
        />

        <p className="text-xs text-slate-300 flex items-center">
          <Icon name="Info" size={12} className="mr-1 text-slate-300" />
          These notes will be included in the analysis report.
        </p>
      </div>

      {/* Patient ID section removed */}
    </div>
  );
};

export default PatientInfoForm;
